import React, {MouseEventHandler, ReactNode} from 'react';

import cn from 'classnames';

import styles from './MoreActions.module.scss';

interface IMoreActionsItemProps {
    label: string,
    icon?: ReactNode,
    onClick?: MouseEventHandler | undefined,
    className?: string,
}

const MoreActionsItem: React.FC<IMoreActionsItemProps> = (
    {
        label,
        icon,
        onClick,
        className,
        ...props
    }) => {

    return (
        <div
            className={cn(styles['dropdown__item'], className)}
            onClick={onClick}
            {...props}
        >
            {icon && (
                <div className={styles['dropdown__item-icon']}>
                    <span className={styles['custom-icon']}>{icon}</span>
                </div>
            )}
            {label}
        </div>
    );
};

export default React.memo(MoreActionsItem);